import type from './CustomModule.type';

const initialState = {
  customLibraryList: null,
  customGroupList: {},
  customLibraryDetail: {},
  customModuleGroupOption: [],
  customLibOptions: [],
  customItemDetails: null,
  libraryPages: [],
  customModulePageList: [],
  customModulePages: [],
  customModulePageControlList: [],
  customModuleDependentControls: [],
  customLibraryCalculationList: [],
  customLibraryPagesCalculationList: [],
  customLibraryPageControlsCalculationList: [],
  systemCanvasControlTypes: [],
  systemCanvasControlTypeById: null,
  systemCanvasModules: [],
  systemCanvasModuleById: null,
  systemCanvasControls: [],
};

const poTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_CUSTOM_MODULE:
      return {
        ...state,
        customLibraryList: action.payload,
      };
    case type.GET_CUSTOM_MODULE_BY_ID:
      return {
        ...state,
        customLibraryDetail: action.payload,
      };
    case type.GET_CUSTOM_MODULE_OPTION:
      return {
        ...state,
        customLibOptions: action.payload,
      };
    case type.GET_CUSTOM_MODULE_GROUP:
      return {
        ...state,
        customGroupList: action.payload,
      };
    case type.UNMOUNT_LIBRARY_LIST:
      return {
        ...state,
        customLibraryList: {},
      };
    case type.UNMOUNT_GROUP_LIST:
      return {
        ...state,
        customGroupList: {},
      };
    case type.GET_CUSTOM_MODULE_FOR_OPTION:
      return {
        ...state,
        customItemDetails: action.payload,
      };
    case type.UNMOUNT_LIBRARY:
      return {
        ...state,
        customLibraryDetail: {},
        customModulePageList: [],
        customModulePageControlList: [],
        customModulePages: [],
        customModuleDependentControls: [],
      };
    case type.LIBRARY_PAGES:
      return {
        ...state,
        libraryPages: action.payload,
      };
    case type.GET_CUSTOM_MODULE_LIST:
      return {
        ...state,
        customModulePageList: action.payload,
      };
    case type.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST:
      return {
        ...state,
        customModulePageControlList: action.payload,
      };
    case type.GET_CUSTOM_MODULE_PAGE_LIST:
      return {
        ...state,
        customModulePages: action.payload,
      };
    case type.GET_CUSTOM_MODULE_DEPENDENT_CONTROL_LIST:
      return {
        ...state,
        customModuleDependentControls: action.payload,
      };
    case type.GET_ALL_CUSTOM_MODULE_FOR_CALCULATION:
      return {
        ...state,
        customLibraryCalculationList: action.payload,
      };
    case type.GET_CUSTOM_MODULE_CALCULATION_PAGE_LIST:
      return {
        ...state,
        customLibraryPagesCalculationList: action?.payload?.pages || [],
      };
    case type.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST_FOR_CALCULATION:
      return {
        ...state,
        customLibraryPageControlsCalculationList: action?.payload || [],
      };
    case type.GET_SYSTEM_CANVAS_CONTROL_TYPES:
      return {
        ...state,
        systemCanvasControlTypes: action?.payload || [],
      };
    case type.GET_SYSTEM_CANVAS_CONTROL_TYPE_BY_ID:
      return {
        ...state,
        systemCanvasControlTypeById: action?.payload || null,
      };
    case type.GET_SYSTEM_CANVAS_MODULES:
      if (action?.payload?.append && Array.isArray(action.payload.modules)) {
        return {
          ...state,
          systemCanvasModules: [...state.systemCanvasModules, ...action.payload.modules],
        };
      }
      if (action?.payload && typeof action.payload === 'object' && !Array.isArray(action.payload) && Array.isArray(action.payload.modules)) {
        return {
          ...state,
          systemCanvasModules: action.payload.modules,
        };
      }
      return {
        ...state,
        systemCanvasModules: action?.payload || [],
      };
    case type.GET_SYSTEM_CANVAS_MODULE_BY_ID:
      return {
        ...state,
        systemCanvasModuleById: action?.payload || null,
      };
    case type.GET_SYSTEM_CANVAS_CONTROLS:
      if (action?.payload?.append && Array.isArray(action.payload.controls)) {
        return {
          ...state,
          systemCanvasControls: [...state.systemCanvasControls, ...action.payload.controls],
        };
      }
      if (action?.payload && typeof action.payload === 'object' && !Array.isArray(action.payload) && Array.isArray(action.payload.controls)) {
        return {
          ...state,
          systemCanvasControls: action.payload.controls,
        };
      }
      return {
        ...state,
        systemCanvasControls: action?.payload || [],
      };
    case type.UPDATE_SYSTEM_CANVAS_MODULE_ACTIVE_STATUS:
      return {
        ...state,
        systemCanvasModules: state.systemCanvasModules.map((module) =>
          String(module._id) === String(action?.payload?.moduleId) ? { ...module, isActive: action?.payload?.isActive } : module,
        ),
      };
    case type.UPDATE_SYSTEM_CANVAS_MODULE_ICON:
      if (!action?.payload?.moduleId || !action?.payload?.iconUrl) {
        return state;
      }
      if (!Array.isArray(state.systemCanvasModules)) {
        return state;
      }
      const moduleIdToUpdate = String(action.payload.moduleId).trim();
      let found = false;
      const updatedModules = state.systemCanvasModules.map((module) => {
        const moduleId = String(module._id || module.id || '').trim();
        if (moduleId && moduleId === moduleIdToUpdate) {
          found = true;
          return { ...module, iconUrl: action.payload.iconUrl };
        }
        return module;
      });
      return {
        ...state,
        systemCanvasModules: updatedModules,
      };
    default:
      return state;
  }
};

export default poTemplateReducer;
